<template>
    <div class="card card-article" v-if="posts.length > 0">
        <div class="card-header bg-light">
            <div class="card-header-title">
                Review
            </div>
        </div>
        <reviews :posts="posts"></reviews>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue'
import axios from 'axios'
import Reviews from './Reviews.vue'

const props = defineProps({
    movieId: {
        type: String,
        required: true
    }
})

const root = inject('root')
const posts = ref([])
const errors = ref([])

const fetchPosts = async () => {
    try {
        const baseUri = process.env.MOVEEK_API_ENDPOINT
        const response = await axios.get(
            `${baseUri}/v1/posts?movie.id=${props.movieId}&category.id=895&page=1&page_size=20&status=publish&publish_at[strictly_before]=${encodeURIComponent(root.moment().toISOString(true))}`
        )
        posts.value = response.data
    } catch (error) {
        errors.value.push(error)
    }
}

onMounted(() => {
    fetchPosts()
})
</script>

<style scoped>
</style>
